// extracted by mini-css-extract-plugin
module.exports = {"altHero":"pj","altProd":"qj","subheading":"rj","subtext":"sj","extrainfo":"tj","copy":"uj","cta":"vj","disabled":"wj"};